import { Box } from "@material-ui/core";
import React from "react";

import { ProductHistoryFilter } from "../components/product_history_filter";
import { ProductHistoryList } from "../components/product_history_list";

export const ProductHistoryListPage: React.FC = () => {
  return (
    <div>
      <Box mb={5}></Box>

      <ProductHistoryFilter />

      <Box mb={2}></Box>

      <ProductHistoryList />
    </div>
  );
};
